import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { AsrRtModule } from '@/store/modules/asr-rt'
import { saveAsrRtResultApi } from '@/api/asr/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveTipDialog',
  props: {
    recordId: null,
    taskName: null
  },
  setup(__props: any) {

const props = __props as {
  recordId: string;
  taskName: string
}

const visible = computed({
  get() {
    return AsrRtModule.alertDialogVisible
  },
  set(newVal) {
    AsrRtModule.ToggleAlertDialogVisible(newVal)
  }
})


const saveCb = computed(() => AsrRtModule.saveCb)
const cancelSaveCb = computed(() => AsrRtModule.cancelSaveCb)
const cancelCb = computed(() => AsrRtModule.cancelCb)

const saveLoading = ref(false)
async function handleSave() {
  saveLoading.value = true
  try {
    await saveAsrRtResultApi({
      recordId: props.recordId,
      save: true,
      name: props.taskName
    })
  } catch (error) {
    console.log('error: ', error)
  }
  saveLoading.value = false
  visible.value = false
  const cbs = saveCb.value
  while(cbs.length > 0) {
    cbs.pop()?.()
  }
}
async function handleCancelSave() {
  visible.value = false
  const cbs = cancelSaveCb.value
  while(cbs.length > 0) {
    cbs.pop()?.()
  }
  try {
    await saveAsrRtResultApi({
      recordId: props.recordId,
      save: false,
      name: props.taskName
    })
  } catch (error) {
    console.log('error: ', error)
  }
}
function handleCancel() {
  const cbs = cancelCb.value
  while(cbs.length > 0) {
    cbs.pop()?.()
  }
  visible.value = false
}
function handleClose() {
  handleCancel()
  AsrRtModule.ClearCb()
}

return { __sfc: true,visible, props, saveCb, cancelSaveCb, cancelCb, saveLoading, handleSave, handleCancelSave, handleCancel, handleClose }
}

})